import React from 'react';

const TOTAL_STEPS = 9;

/**
 * @param {{ conv: import('../../types/tiv').TivConversation, onClick: () => void }} props
 */
export default function ConversationCard({ conv, onClick }) {
  const isDraft = conv.status === 'draft';
  const progressPct = Math.round((conv.step / TOTAL_STEPS) * 100);

  return (
    <button
      onClick={onClick}
      className="w-full text-left bg-white/[0.03] border border-white/[0.06] hover:border-white/[0.12] transition-colors rounded-2xl p-4"
    >
      <div className="flex items-start justify-between gap-3">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1.5">
            <span className="text-sm font-semibold text-white truncate">
              {conv.title || conv.formation_label || 'Lettre sans titre'}
            </span>
            <span className={[
              'shrink-0 text-[10px] font-bold px-2 py-0.5 rounded-full uppercase',
              isDraft
                ? 'bg-amber-400/10 text-amber-400'
                : 'bg-emerald-400/10 text-emerald-400',
            ].join(' ')}>
              {isDraft ? 'En cours' : 'Finalisée'}
            </span>
          </div>

          {conv.formation_label && conv.title !== conv.formation_label && (
            <p className="text-xs text-zinc-500 mb-2 truncate">{conv.formation_label}</p>
          )}

          {isDraft && (
            <div className="flex items-center gap-2">
              <div className="flex-1 h-1 rounded-full bg-white/[0.08]">
                <div
                  className="h-full rounded-full bg-amber-400 transition-all"
                  style={{ width: `${progressPct}%` }}
                />
              </div>
              <span className="text-[10px] text-amber-400 font-semibold whitespace-nowrap">
                Partie {conv.step}/{TOTAL_STEPS}
              </span>
            </div>
          )}
        </div>

        <span className="text-zinc-500 text-sm shrink-0">›</span>
      </div>
    </button>
  );
}
